import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Inbox } from "lucide-react";
import { api } from "@/lib/api";

const STATUS_STYLES = {
  New: "border-emerald-600/40 text-emerald-700",
  Contacted: "border-sky-600/40 text-sky-700",
  "In Review": "border-[#6D28D9]/50 text-[#6D28D9]",
  Closed: "border-slate-300 text-slate-500",
};

export const MyEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  useEffect(() => { api.get("/my-enquiries").then((r) => setEnquiries(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="account-enquiries-list" className="mt-6 space-y-4">
      {enquiries.map((l) => (
        <div key={l.id} data-testid={`account-enquiry-${l.id}`} className="flex flex-col gap-4 border border-slate-200 bg-[#F6F4FD]/70 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="font-display text-lg font-medium text-[#6D28D9]">{l.share_interest}</p>
            <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.18em] text-slate-500">{l.investment_range} · {new Date(l.created_at).toLocaleString("en-IN")}</p>
            {l.message && <p className="mt-2 text-sm text-slate-500">{l.message}</p>}
          </div>
          <span className={`shrink-0 self-start border px-3 py-1.5 font-mono2 text-[9px] uppercase tracking-[0.18em] sm:self-center ${STATUS_STYLES[l.status] || STATUS_STYLES.New}`}>{l.status}</span>
        </div>
      ))}
      {enquiries.length === 0 && (
        <div className="flex flex-col items-center border border-dashed border-slate-300 py-16 text-center">
          <Inbox className="h-6 w-6 text-slate-400" />
          <p data-testid="account-no-enquiries" className="mt-4 font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">No enquiries yet</p>
          <Link to="/" className="mt-6 flex items-center gap-2 border border-[#6D28D9]/40 px-6 py-3 font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#6D28D9] transition-colors hover:bg-[#6D28D9]/10">
            <ArrowLeft className="h-3.5 w-3.5" /> Browse opportunities
          </Link>
        </div>
      )}
    </div>
  );
};
